<template>
  <v-breadcrumbs v-if="!isMobile || (isMobile && crumbs.length > 1)" :items="crumbs">
    <template #title="{ item }">
      <div class="item-flex">
        <span>{{ item.title }}</span>
        <span v-if="item.siblings && item.siblings.length > 1 && item.siblings.every(e => 'icon' in e)" class="breadcrumb-path-siblings">
          <BaseMenu
            :placement="'bottom'"
            :offset="[0, 16]"
          >
            <!-- allow click = false to remove active state on click  -->
            <IconButton
              :id="`${item.title.trim()}`"
              :mirrored="show"
              class="breadcrumb-dropdown-icon"
              :icon="'expand_more'"
              :width="22"
              :height="22"
              :allowClick="false"
              @click.stop.prevent="toggleShow"
            />
            <template #menu="{closeMenu}">
              <ul>
                <li
                  v-for="(s, idx) in item.siblings.filter(i => i.meta && Object.keys(i.meta).length > 0)"
                  :key="`${s.meta.breadCrumb.trim()}_${idx}`"
                >
                  <BaseMenuButton
                    :disabled="s.meta.breadCrumb === item.title"
                    @click.stop="navigate(s.name), closeMenu(), toggleShow()"
                  >
                    <SVGIcon
                      :iconName="s.meta.icon"
                      :width="'22px'"
                      :height="'22px'"
                    />
                    <span>{{ s.meta.breadCrumb }}</span>
                  </BaseMenuButton>
                </li>
              </ul>
            </template>
          </BaseMenu>
        </span>
      </div>
    </template>
  </v-breadcrumbs>
</template>
<script>
import IconButton from '@/components/IconButton.vue';
import BaseMenu from '@/components/BaseMenu.vue';
import BaseMenuButton from '@/components/BaseMenuButton.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import { useMobile } from '@/composables/useMobile';

export default {
  name: 'BreadcrumbNavigation',
  components: {
    IconButton,
    BaseMenu,
    BaseMenuButton,
    SVGIcon,
  },
  setup() {
    const { isMobile } = useMobile();
    return {
      isMobile,
    };
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    crumbs() {
      return this.$route.matched
        .filter((r) => r.meta?.breadCrumb) // only include routes that define a breadcrumb
        .map((routeRecord, idx, matched) => {
          const parent = matched[idx - 1];
          const obj = {
            path: routeRecord.path, // still has :params if defined
            to: {
              name: routeRecord.name, // safer than building path manually
              params: this.$route.params, // keep current params (e.g. project_id)
            },
            title: routeRecord.meta.breadCrumb,
            siblings: parent?.children
              ? parent.children.filter(
                (item) => (!item.permissions
                  || item.permissions.some((role) => this.user.role === role))
                && item.meta?.breadCrumb,
              )
              : null,
          };
          return obj;
        });
    },
  },
  methods: {
    navigate(name) {
      this.$router.push({ name });
    },
    toggleShow() {
      this.show = !this.show;
    },
  },
};
</script>
<style lang="scss">
.item-flex {
  display: flex;
  padding: 5px;
  flex-wrap: nowrap;
  overflow-x: hidden;
  overflow-y: hidden;
  span {
    width: fit-content;
    white-space: nowrap;
    font-size: 1rem;
  }
}

.v-breadcrumbs {
  padding: 0;
}

.v-breadcrumbs .v-breadcrumbs-item--link,
.v-breadcrumbs .v-icon {
  font-size: 1.0rem;
}

.v-breadcrumbs li.v-breadcrumbs-item--disabled:first-child{
  opacity: 1;
}

.v-breadcrumbs li.v-breadcrumbs-item--disabled:not(:first-child) {
  opacity: 1;
  text-decoration: underline;
  text-decoration-thickness: 2px;
}

.breadcrumb-path-siblings {
  margin-left: 8px;
  pointer-events: auto;
}

.breadcrumb-dropdown-icon {
  z-index: 4;
}

.breadcrumb-dropdown-icon.active {
  color: var(--color-white) !important;
}
</style>
